<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Shrinking</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/Text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/Text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/Text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/Text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/Text/ch005#chapter-1">Chapter 1</a><ol class="toc"><li id="toc-li-6"><a href="#/Text/ch005#in-the-beginning">In the Beginning</a></li>
</ol></li>
<li id="toc-li-7"><span href="#/Text/ch006#chapter-2" title="Link target outside of Sample">Chapter 2</span><ol class="toc"><li id="toc-li-8"><span href="#/Text/ch006#camping-without-permission" title="Link target outside of Sample">Camping Without Permission</span></li>
</ol></li>
<li id="toc-li-9"><span href="#/Text/ch007#chapter-3" title="Link target outside of Sample">Chapter 3</span><ol class="toc"><li id="toc-li-10"><span href="#/Text/ch007#the-nightmare-begins" title="Link target outside of Sample">The Nightmare Begins</span></li>
</ol></li>
<li id="toc-li-11"><span href="#/Text/ch008#chapter-4" title="Link target outside of Sample">Chapter 4</span><ol class="toc"><li id="toc-li-12"><span href="#/Text/ch008#the-dolls-house" title="Link target outside of Sample">The Doll’s House</span></li>
</ol></li>
<li id="toc-li-13"><span href="#/Text/ch009#chapter-5" title="Link target outside of Sample">Chapter 5</span><ol class="toc"><li id="toc-li-14"><span href="#/Text/ch009#arachnophobia" title="Link target outside of Sample">Arachnophobia</span></li>
</ol></li>
<li id="toc-li-15"><span href="#/Text/ch010#chapter-6" title="Link target outside of Sample">Chapter 6</span><ol class="toc"><li id="toc-li-16"><span href="#/Text/ch010#journey-to-the-moss-forest" title="Link target outside of Sample">Journey to the Moss Forest</span></li>
</ol></li>
<li id="toc-li-17"><span href="#/Text/ch011#chapter-7" title="Link target outside of Sample">Chapter 7</span><ol class="toc"><li id="toc-li-18"><span href="#/Text/ch011#land-of-the-water-bears" title="Link target outside of Sample">Land of the Water Bears</span></li>
</ol></li>
<li id="toc-li-19"><span href="#/Text/ch012#chapter-8" title="Link target outside of Sample">Chapter 8</span><ol class="toc"><li id="toc-li-20"><span href="#/Text/ch012#where-the-water-scorpion-is-king" title="Link target outside of Sample">Where the Water Scorpion Is King</span></li>
</ol></li>
<li id="toc-li-21"><span href="#/Text/ch013#chapter-9" title="Link target outside of Sample">Chapter 9</span><ol class="toc"><li id="toc-li-22"><span href="#/Text/ch013#land-of-the-giant-eye" title="Link target outside of Sample">Land of the Giant Eye</span></li>
</ol></li>
<li id="toc-li-23"><span href="#/Text/ch014#chapter-10" title="Link target outside of Sample">Chapter 10</span><ol class="toc"><li id="toc-li-24"><span href="#/Text/ch014#journey-to-new-mars" title="Link target outside of Sample">Journey to New Mars</span></li>
</ol></li>
<li id="toc-li-25"><span href="#/Text/ch015#chapter-11" title="Link target outside of Sample">Chapter 11</span><ol class="toc"><li id="toc-li-26"><span href="#/Text/ch015#germ-warfare" title="Link target outside of Sample">Germ Warfare</span></li>
</ol></li>
<li id="toc-li-27"><span href="#/Text/ch016#chapter-12" title="Link target outside of Sample">Chapter 12</span><ol class="toc"><li id="toc-li-28"><span href="#/Text/ch016#back-to-normal" title="Link target outside of Sample">Back to Normal</span></li>
</ol></li>
<li id="toc-li-29"><span href="#/Text/ch017#chapter-13" title="Link target outside of Sample">Chapter 13</span><ol class="toc"><li id="toc-li-30"><span href="#/Text/ch017#the-meeting" title="Link target outside of Sample">The Meeting</span></li>
</ol></li>
<li id="toc-li-31"><span href="#/Text/ch018#glossary-of-terms-used" title="Link target outside of Sample">Glossary of Terms Used</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?b42bb530